"use client";

export function RecognitionSection() {
  return (
    <section className="pt-0 pb-0">
      <div>
        {/* WeAreTeachers */}
        <div className="relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] bg-white bg-[url('/images/marketing/educators/weAreTeachers/background.webp')] bg-cover bg-center">
          <div className="container mx-auto px-4 max-w-6xl py-10 md:py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div className="flex items-center justify-center">
                <img
                  src="/images/marketing/educators/weAreTeachers/logo.svg"
                  alt="WeAreTeachers"
                  className="w-full max-w-[520px] h-auto"
                />
              </div>
              <div className="flex flex-col items-center justify-center text-center gap-4">
                <img
                  src="/images/marketing/educators/weAreTeachers/badge.webp"
                  alt="WeAreTeachers Teacher Picks"
                  className="w-44 md:w-56 h-auto"
                />
                <p className="text-ink-slate charlie-kingdom-font text-lg md:text-xl max-w-md">
                  <span className="relative -top-1">
                    We are proud to have received WeAreTeachers.com&apos;s Teacher Picks!
                  </span>
                </p>
              </div>
            </div>
            <p className="mt-8 text-ink-slate text-sm md:text-base leading-relaxed">
              WeAreTeachers.com is a leading online community and resource hub for K–12 educators.
              It provides classroom ideas, lesson plans, and professional resources created by and
              for teachers, and supports educator voices across the education space. Its
              long-standing presence and large teacher audience make it a trusted name in education.
            </p>
          </div>
        </div>

        {/* Leanlab Education */}
        <div className="relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] bg-white bg-[url('/images/marketing/educators/leanLabEdu/background.webp')] bg-cover bg-center">
          <div className="container mx-auto px-4 max-w-6xl py-10 md:py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div className="flex items-center justify-center">
                <img
                  src="/images/marketing/educators/leanLabEdu/logo.svg"
                  alt="Leanlab Education"
                  className="w-full max-w-[520px] h-auto"
                />
              </div>
              <div className="flex flex-col items-center justify-center text-center gap-4">
                <img
                  src="/images/marketing/educators/leanLabEdu/badge.webp"
                  alt="Leanlab Education Codesign product Certification"
                  className="w-44 md:w-56 h-auto"
                />
                <p className="text-white/90 charlie-kingdom-font text-lg md:text-xl max-w-md">
                  <span className="relative -top-1">
                    The Codesign Product Certification was awarded for improving the platform based
                    on user feedback.
                  </span>
                </p>
              </div>
            </div>
            <p className="mt-8 text-white/80 text-sm md:text-base leading-relaxed">
              Leanlab Education is a nonprofit research organization that connects schools,
              educators, and edtech companies to improve learning tools through real classroom
              testing. Through structured codesign research and documented partnerships, Leanlab
              helps evaluate and refine educational products. Its work bridges research, schools,
              and innovation in education technology.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
